export default (string = "") => {
  if (string === null) {
    return null;
  }

  if (string.endsWith('%')) {
    return parseFloat(string.slice(0, -1).replace(/\./g, '').replace(/,/g, '.')) / 100;
  }

  return parseFloat(string.replace(/\./g, '').replace(/,/g, '.'));
};